import { Component, OnInit, OnDestroy } from '@angular/core';
import { MainService } from 'src/app/services/main.service';
import { WaterBottle } from 'src/app/models/waterBottle';
import { EventService } from 'src/app/services/event.service';
import { from } from 'rxjs';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { UserDataService } from 'src/app/services/user-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  public waterBottles?: Array<WaterBottle>;
  searchText: string;
  bottleSearch = [];
  variants = [];

  constructor(
    private eventService: EventService,
    private userDataService: UserDataService,
    private mainService: MainService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.userDataService.configuratorStatus = null;
    this.eventService.showSpinner();
    this.loadHoliday();
  }

  ngOnDestroy() {
  }

  private loadHoliday() {
    this.mainService.getHolidayData().then(response => {
      const date = new Date();
      const year = '' + date.getFullYear();
      let month = '' + (date.getMonth() + 1);
      if (month.length < 2) {
        month = '0' + month;
      }
      let day = '' + date.getDate();
      if (day.length < 2) {
        day = '0' + day;
      }
      const dateString = year + month + day;
      if (dateString >= response.from && dateString <= response.to) {
        this.eventService.hideSpinner();
        const lang = this.translate.instant('lang');
        response.message.forEach(text => {
          if (text.lang === lang) {
            this.eventService.setTextPopupClickable(false);
            this.eventService.setTextPopupText(text.text);
            this.eventService.showTextPopup();
          }
        });
      } else {
        this.loadWaterBottles();
      }
    }).catch(error => {
      this.loadWaterBottles();
    });
  }

  private loadWaterBottles() {
    this.mainService.getWaterBottles().then(response => {
      this.waterBottles = response.items;
      this.refreshVariants();
      this.eventService.hideSpinner();
    }).catch(error => {
      this.eventService.hideSpinner();
    });
  }

  private refreshVariants() {
    const source = from(this.waterBottles);
    const example = source.pipe(groupBy(bottle => bottle.variant),
      mergeMap(group => group.pipe(toArray()))
    );
    this.variants = [];
    example.subscribe(val => this.variants.push(val));
  }

  search() {
    this.bottleSearch = [];
    this.waterBottles = [];
    this.eventService.showSpinner();
    this.mainService.getWaterBottles().then(response => {
      this.waterBottles = response.items;
      this.waterBottles.forEach(bottle => {
        if (bottle.name.toLowerCase().includes(this.searchText)) {
          this.bottleSearch.push(bottle);
        } else if (bottle.variant.toLowerCase().includes(this.searchText)) {
          this.bottleSearch.push(bottle);
        } else {
          return;
        }
      });
      this.waterBottles = this.bottleSearch;
      this.refreshVariants()
      this.eventService.hideSpinner();
    }).catch(error => {
      this.eventService.hideSpinner();
    });
  }

}
